
import './App.css';

import 'bootstrap/dist/css/bootstrap.min.css';

import { NavBar } from './components/NavBar';
import { Banner } from './components/Banner';
import { Skills } from './components/Skills';
import { Projects } from './components/Projects';
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { TourismGuide } from './components/projects/TourismGuide';
import { BlossomHealth } from './components/projects/BlossomHealth';
import { ObjectDetector } from './components/projects/ObjectDetector';
import { FaceRecognition } from './components/projects/FaceRecognition';
import { LanguageTranslator } from './components/projects/LanguageTranslator';

function App() {
    return ( 
      <div className="App">
        <Router>
          <Routes>
            <Route path="/" element={<>
              <NavBar />
              <Banner />
              <Skills />
              <Projects />
              <Contact />
              <Footer />
            </>} />
            <Route path="/tourism" element={<TourismGuide />} />
            <Route path="/blossom-health" element={<BlossomHealth />} />
            <Route path="/object-detector" element={<ObjectDetector />} />
            <Route path="/face-recognition" element={<FaceRecognition />} />
            <Route path="/language-translator" element={<LanguageTranslator />} />
          </Routes>
        </Router>
      </div>
    );
}

export default App;